import ContinueButton from "components/selection-components/customize-wizard/continue-button";
import { PreorderContext } from "context/preorder-context";
import { t } from "i18next";
import { useContext } from "react";

interface IPreorderContinueButton {
    key?: string;
    onContinue: () => Promise<void>;
}

const PreorderContinueButton = ({ onContinue }: IPreorderContinueButton) => {
    const {
        currentTotalQuantity,
        isPreorderValid,
        nextInvalidGroup,
        setActiveTabIndex,
        activeTabIndex,
    } = useContext(PreorderContext) || {};

    const validPreorderButtonText =
        currentTotalQuantity === 0
            ? t("preorder.continueWithoutItems")
            : t("preorder.continueWithItemsPrefix", {
                  totalQuantity: currentTotalQuantity,
                  suffix:
                      currentTotalQuantity === 1
                          ? t("preorder.continueWithItemsSingularSuffix")
                          : t("preorder.continueWithItemsPluralisSuffix"),
              });

    const helperButtonText = t("preorder.continueWithGroupHelperText", {
        menuGroup: nextInvalidGroup?.name || "",
    });

    const handleClick = async () => {
        if (isPreorderValid) {
            await onContinue();
        } else if (nextInvalidGroup?.index !== undefined && setActiveTabIndex) {
            // Force a state change even when clicking on the same tab repeatedly
            if (activeTabIndex === nextInvalidGroup.index) {
                setActiveTabIndex(-1);
                setTimeout(() => {
                    setActiveTabIndex(nextInvalidGroup.index);
                }, 0);
            } else {
                setActiveTabIndex(nextInvalidGroup.index);
            }
        }
    };

    return (
        <ContinueButton
            buttonText={isPreorderValid ? validPreorderButtonText : helperButtonText}
            onContinue={handleClick}
        />
    );
};

export default PreorderContinueButton;
